import { render, staticRenderFns } from "./ZoneMap.vue?vue&type=template&id=2b89395c&scoped=true&"
import script from "./ZoneMap.vue?vue&type=script&lang=js&"
export * from "./ZoneMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89395c",
  null
  
)

export default component.exports